import { render, staticRenderFns } from "./CartButton.vue?vue&type=template&id=b22fb7a0&scoped=true&"
import script from "./CartButton.vue?vue&type=script&lang=js&"
export * from "./CartButton.vue?vue&type=script&lang=js&"
import style0 from "./CartButton.vue?vue&type=style&index=0&id=b22fb7a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22fb7a0",
  null
  
)

export default component.exports